/**
 *レスポンシブチェック
 *cssのwidth=2でSP以下を判断
 **/
export var resizeFunc,resizecheck;
export function resizeFuncCheck() {
        resizeFunc = function () {
            resizecheck = $('#responsibleCheck').width();
        }
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_resizecheck.js
// module id = 1
// module chunks = 0